import "./styles.less";

import { Affix } from "antd";
import { LeadButtons } from "../../../Components/Property/InformationRequest/LeadButtons/web";
import React from "react";

export const PropertyAffixBottom = ({ id, mode, isProject = false, owner }) => {
	return (
		<Affix className="pd_affix_bottom" offsetBottom={0}>
			<div className="pd_affix_bottom_content">
				<LeadButtons
					id={id}
					owner={owner}
					isProject={isProject}
					isInListing
					source="propertyDetailMain"
					ctaToShow={{
						phone: true,
						whatsapp: true,
						contact: true
					}}
				/>
			</div>
		</Affix>
	);
};
